// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"6c028f87","453":"b2c504ef","581":"f96d349e","905":"a6b31bc3"}[chunkId] + ".chunk.js";
};